import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import { Table } from '../../../dpe-usco'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import leftArrow from '../../../dpe-usco/asset/icons/left_arrow.svg'
import { getSalesYear, getVideoByYear, deleteTrainingVideo } from '../../../services/apiHelper'
import UploadTrainingVideoForm from '../../../components/ModalForms/UploadTrainingVideoForm'
import { generateYearsOptions } from '../../../services/utils'

const VideoPlayer = ({ videoUrl }) => {
  return (
    <div className="video-player">
      <div className="video-overlay">
        <iframe
          src={`${videoUrl}?autoplay=1`}
          title="Video"
          allowFullScreen
          frameBorder="0"
        ></iframe>
      </div>
    </div>
  )
}

export const UploadCompanyTrainingVideo = () => {
  const [showModal, setShowModal] = useState(false)
  const [salesYear, setSalesYear] = useState('')
  const [isEmptyStatus, setIsEmptyStatus] = useState(false)
  const [data, setData] = useState([])
  const [isVideoEdit, setIsVideoEdit] = useState(false)
  const [videoUrl, setVideoUrl] = useState(false)
  const [editYear, setEditYear] = useState('')
  const [deleteYear, setDeleteYear] = useState('')
  const [loading, setLoading] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [deleteError, setDeleteError] = useState(false)
  const [addButtonYears, setAddButtonYears] = useState([])

  let history = useHistory()

  const reset = arg => {
    setVideoUrl(false)
    setEditYear('')
    setDeleteYear('')
    setLoading(false)
    setIsDelete(false)
    setDeleteError('')
  }

  const uploadTrainingVideo = () => {
    setIsVideoEdit(false)
    setEditYear('')
    setShowModal(true)
  }

  const editTrainingVideo = (year, path) => {
    setShowModal(true)
    setIsVideoEdit(true)
    setEditYear(year)
    setVideoUrl(path)
  }

  const deleteTraining = year => {
    setIsDelete(true)
    setDeleteYear(year)
  }

  const deleteHandler = async() => {
    setDeleteError('loading')
    await deleteTrainingVideo('Enogen-Stewardship-'+deleteYear).then(
      response => {
        if (response?.data?.training_steps) {
          setIsDelete(false)
          window.location.reload()
        } else {
          setDeleteError('error')
        }
      })
  }

  useEffect(()=>{
    const retrieveSalesYear = async () => {
      setLoading(true)
      await getSalesYear().then(sales_year=>{
        setSalesYear(sales_year.data.sales_year)
      })
    }
    retrieveSalesYear()
  },[])

  useEffect(() => {
    if (salesYear) {
      const salesYearMinusOne = (parseInt(salesYear) - 1).toString()
      const yearOptions = generateYearsOptions(salesYearMinusOne, 3)
      let missingYears = []
      Promise.all(
        yearOptions.map(async yearOption => {
          try {
            const videoData = await getVideoByYear(yearOption.value)
            if (videoData?.data) {
              const videoIndex = videoData?.data?.training_steps.length - 1
              const record = {
                year: yearOption?.value,
                video: <VideoPlayer videoUrl={videoData?.data?.training_steps[videoIndex]?.training} />,
                action: (
                  <>
                    <Button type="outline" text='Edit' customClassName="mr20" clickHandler={()=>editTrainingVideo(yearOption?.value, videoData?.data?.training_steps[videoIndex]?.training)} />
                    <Button type="error" text='Delete' customClassName="mr20" clickHandler={()=>deleteTraining(yearOption?.value)} />
                  </>
                ),
                customRowClass:'h200'
              }
              return record
            } else {
              missingYears.push(yearOption.value)
              return null
            }
          } catch (error) {
            missingYears = []
            return null
          }
        })
      )
        .then(recordDetail => {
          setAddButtonYears(missingYears)
          recordDetail = recordDetail.filter(record => record !== null)
          if(recordDetail.length>0) {
            setData(recordDetail)
          } else {
            setIsEmptyStatus(true)
          }
          setLoading(false)
        })
        .catch(() => {
          setIsEmptyStatus(true)
        })
    }
  }, [salesYear])

  const buttons = (
    <div className='df'>
      <div>
        <Button
          type="outline"
          text='Add Video'
          customClassName="mr20 syn-button-success"
          clickHandler={uploadTrainingVideo}
        />
      </div>
    </div>)

  const headerCell = (value, maxWidth) => {
    return (
      <div key={value} className={`cell df aic maw${maxWidth}`}>
        <span>{value}</span>
      </div>
    )
  }
  const structure = {
    headers: [
      {
        value: 'Year',
        maxWidth: 250,
        format(){
          return headerCell(this.value, this.maxWidth)
        }
      },
      { 
        value: 'Video',
        format(){
          return headerCell(this.value)
        }
      },
      { 
        value: 'Action',
        maxWidth: 350,
        format(){
          return headerCell(this.value, this.maxWidth)
        }
      }
    ],
    dataKeys: [
      'year',
      'video',
      'action'
    ],
    rowFormat: {
      year: {
        format: year => {
          return(<div className=''>{year}</div>)
        },
        customStyle: 'maw250'
      },
      action: {
        format: pdf => {
          return <div className='fw600 c-green pr25'>{pdf}</div>
        },
        customStyle: 'maw350'
      }
    }
  }

  return (
    <>
      {showModal && 
          <div data-testid="adminModal">
            <Modal
              autoHeight
              show={showModal}
              handleClose={reset}
            >
              <UploadTrainingVideoForm addButtonYears={addButtonYears}  handleClose={() => setShowModal(false)} isVideoEdit={isVideoEdit} editYear={editYear} videoUrl={videoUrl} />
            </Modal>
          </div>
      }

      {isDelete &&
          <Modal
            autoHeight
            show={isDelete}
            handleClose={reset}
            customModalClassName='z1000'
          >
            <div className='w500 tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <div className='fw600 ml10'>
                    Delete Training Video? 
                  </div>
                </div>
              </div>
              {(deleteError === 'loading')?
                <>
                  <div className='p25 h80 df aic jcfs wowb'>
                    <span className='wspn fz15'>
                    Delete in progress. Please wait.
                    </span>
                  </div>
                  <div className='bt1-s-lightgray df aic jcfe'>
                    <div className='mt8 mb8 mr8'>
                      <Button disabled customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset}/>
                    </div>
                  </div>
                </> :
                (deleteError === 'error') ? 
                  <>
                    <div className='p25 h80 df aic jcfs wowb'>
                      <span className='wspn fz15'>
                      Something went wrong. Please contact your admin.
                      </span>
                    </div>
                    <div className='bt1-s-lightgray df aic jcfe'>
                      <div className='mt8 mb8 mr8'>
                        <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset}/>
                      </div>
                    </div>
                  </>
                  :
                  <>
                    <div className='p25 h80 df aic jcfs wowb'>
                      <span className='wspn fz15 tac'>
                      Are you sure you want to permanently delete this training video? Completion of the {deleteYear} training won&lsquo;t be possible afterward.
                      </span>
                    </div>
                    <div className='bt1-s-lightgray df aic jcfe'>
                      <div className='mt8 mb8 mr8'>
                        <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset}/>
                        <Button customClassName='miw70' type='error' text='Delete' 
                          onClick={deleteHandler}/>
                      </div>
                    </div>
                  </>
              }
            </div>
          </Modal>
      }


      {loading ? <div className="df aic jcc h175"> <div className='loader h80 w80'/> </div>  :
        <>
          <button
            className='df aic jcsb posf l20'
            style={{
              background: 'none',
              color: 'inherit',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit'
            }}
            onClick={() => history.goBack()}
          >
            <img src={leftArrow} alt='return arrow' className='curp mr10' />
            <span className='fz17 c-neutral-500 fs'>Back</span>
          </button>
          <DetailView button={addButtonYears.length > 0 ? buttons : null} title={'Upload Training Video'} disableBack={true}>
            <>
              <Table structure={structure} data={data} statusComponent={isEmptyStatus ? <div>No contracts.</div> : null}/>
            </>
          </DetailView>
        </>
      }
    </>
  )
}

export default UploadCompanyTrainingVideo